var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"diagram",attrs:{"viewBox":"0 0 42 42"}},[_c('circle',{ref:"mainDiagram",attrs:{"stroke":_vm.stroke,"stroke-dasharray":_vm.dasharray,"stroke-dashoffset":_vm.dashoffset,"stroke-width":_vm.strokeWidth,"r":_vm.radius,"cx":"50%","cy":"50%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }